module.exports = __webpack_public_path__ + "PairanoiaPattern.png";